import { useState, useEffect } from 'preact/hooks';
import { Product } from '../../models/Product';
import './ProductQuestions.less';
import { apiClient } from '../../services/ApiClient';
import { useSeedRandom } from '../../hooks/useSeedRandom';
import ProductRelatedQuestionList from '../../components/product/ProductRelatedQuestionList';
import ProductQuestionBubble from '../../components/product/ProductQuestionBubble';
import useAppDispatch from '../../hooks/useAppDispatch';
import { useTranslation } from '../../hooks/useTranslation';
import { dispatchEvent } from '../../services/EventService';

export type ProductQuestionsProps = {
    productId: string;
    limit: number;
    shuffle: boolean;
};

const ProductPageQuestions = ({
    productId,
    limit,
    shuffle
}: ProductQuestionsProps) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [product, setProduct] = useState<Product | null>(null);
    const random = useSeedRandom(
        productId,
        product?.relatedAnalysisQuestions?.length ?? 0
    );
    useEffect(() => {
        apiClient.product
            .getProductByProductId({ params: { productId } })
            .then(result => setProduct(result))
            .catch(() => {});
    }, []);
    const startIndex = shuffle ? random : 0;
    limit = Math.min(limit, product?.relatedAnalysisQuestions?.length ?? 0);
    const relatedAnalysisQuestions = product?.relatedAnalysisQuestions
        ? [
              ...product.relatedAnalysisQuestions,
              ...product.relatedAnalysisQuestions
          ].slice(startIndex, startIndex + limit)
        : [];

    if (!product || !relatedAnalysisQuestions.length) {
        return null;
    }
    return (
        <div className={`bri-ProductQuestions`}>
            <ProductRelatedQuestionList>
                {relatedAnalysisQuestions.map((question, index) => (
                    <ProductQuestionBubble
                        text={question}
                        onClick={question =>
                            dispatch.featureState.startFeature({
                                featureType: 'product-detail',
                                productId,
                                source: 'web',
                                initialQuestion: question
                            })
                        }
                    />
                ))}
                <ProductQuestionBubble
                    startIconId="brilliant-logo"
                    text={t('PRODUCT_QUESTION_BANNER_DEFAULT_BUTTON_LABEL')}
                    onClick={() => {
                        dispatchEvent({
                            type: 'bri.click_suggested_question',
                            isInteraction: true,
                            productIds: [productId],
                            source: 'web'
                        });
                        void dispatch.featureState.startFeature({
                            featureType: 'product-detail',
                            productId,
                            source: 'web'
                        });
                    }}
                />
            </ProductRelatedQuestionList>
        </div>
    );
};

export default ProductPageQuestions;
